import { render } from "./Navigation.vue?vue&type=template&id=fc140f40"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fikri/Work/PRiADI/code/priadi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__